/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { showSelectedDamageCar, showSelectedDamageMB } from '../../../actions/modalActions';
import { setTimeShow, setStep, handleStepBack, handleNextStep, setIsInEdit, setSelectedAllTrue, setSelectedAllFalse, setSelectedDamagePhotoTypes, setDamagePosition, saveDamageSelected, setGlassDrillDown, setGlassTooltip } from '../../../actions/claimSubmitActions';
import { isMobile } from 'react-device-detect';
import { FNOL_CLAIM_PROGRESS_MOBILE } from '../../../routes/routes';
import { navigateTo } from '../../../actions/navigationActions';
import { CLAIM_TYPE_GLASS } from '../../../constants/constants';

class FnolStep5Sub1 extends React.Component<any, any>  {
    constructor(props) {
        super(props)
        this.state = {
            damageIsInEdit: false,
            damagehasLoaded: false,
        }
        this.handleSelectDamagePos = this.handleSelectDamagePos.bind(this);
        this.checkDamageNext = this.checkDamageNext.bind(this);
        this.handleEditSelectedDamage = this.handleEditSelectedDamage.bind(this);
        this.handleSelectAll = this.handleSelectAll.bind(this);
        this.handleSubmitDamageReportStep1 = this.handleSubmitDamageReportStep1.bind(this);
        this.checkMobileRedirect = this.checkMobileRedirect.bind(this);
    }

    handleSubmitDamageReportStep1() {
        if (this.props.claimSubmit.claimType === CLAIM_TYPE_GLASS && this.props.claimSubmit.hasDamageSelected) {
            this.props.dispatchHandleNextStep();
            this.checkMobileRedirect()
        }
        else {
            this.props.dispatchHandleNextStep();
        }
    }

    checkMobileRedirect() {
        if (isMobile && (this.props.claimSubmit.lastCompletedStep > (this.props.claimSubmit.selectedClaimStep.step))) {
            this.props.redirectTo(FNOL_CLAIM_PROGRESS_MOBILE);
            this.props.dispatchSetStep(this.props.claimSubmit.lastCompletedStep, this.props.claimSubmit.lastCompletedSubStep);
        }
    }

    checkDamageNext() {
        if (this.props.claimSubmit.selectedDamagePhotoTypes.length == 0 && !this.state.selectAll) {
            this.setState({ continueDamage: true })
        }
        else if (this.state.selectAll) {
            this.setState({ continueDamage: false })
        }
        else if (this.props.claimSubmit.selectedDamagePhotoTypes.length > 0) {
            this.setState({ continueDamage: false })
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);        
    }

    async handleSelectAll() {
        if (this.state.selectAll) {
            await this.setState({
                selectAll: false
            })
            this.props.dispatchSetSelectedAllFalse();
        }
        else {
            await this.setState({ selectAll: true })
            this.props.dispatchSetSelectedAllTrue();
        }
        await this.checkDamageNext();
    }

    async handleRemoveFromList(description) {
        if (this.state.damageIsInEdit) {
            await this.props.dispatchSaveDamageSelected(description);
        }
    }

    async handleEditSelectedDamage() {
        await this.setState({ damageIsInEdit: !this.state.damageIsInEdit });
    }

    async handleSelectDamagePos(pos: string) {
        if (this.props.claimSubmit.claimType === CLAIM_TYPE_GLASS) {
            await this.setState({ damageIsInEdit: false });
            await this.props.dispatchIsInEdit(this.state.damageIsInEdit);
            if (pos === "front" ) {
                await this.props.dispatchSaveDamageSelected("Windshield");
                await this.props.dispatchSetGlassTooltip("Windshield");
                setTimeout(
                    () => {
                        this.props.dispatchSetGlassTooltip("")
                    }, 3000);
            }
            else if (pos === "back") {
               
                await this.props.dispatchSaveDamageSelected("Back window");
                await this.props.dispatchSetGlassTooltip("Back window");
                setTimeout(
                    () => {
                        this.props.dispatchSetGlassTooltip("")
                    }, 3000);
            }
            else {
                await this.props.dispatchSetGlassTooltip("");
            }
            await this.props.dispatchSetGlassDrillDown(true, pos);
            await this.checkDamageNext();
        } else {
            await this.setState({ damageIsInEdit: false });
            await this.props.dispatchIsInEdit(this.state.damageIsInEdit);
            this.props.claimSubmit.isCar ? await this.props.dispatchShowSelectedDamageCar(pos) : await this.props.dispatchShowSelectedDamageMB(pos);
            await this.checkDamageNext();
        }
        
    }

    async handleSelectDamagePosGLASSClaims(pos) {
        /*NOTE: Content for this should be replaced with actual GlassClaim links to the Drilldown pages for each section*/
        await this.setState({ damageIsInEdit: false });
        await this.props.dispatchIsInEdit(this.state.damageIsInEdit);
        this.props.claimSubmit.isCar ? await this.props.dispatchShowSelectedDamageCar(pos) : await this.props.dispatchShowSelectedDamageMB(pos);
        await this.checkDamageNext();
    }

    public render() {
        let damageDetailList = <div></div>;
        let damageSelectImgTitle = "Click to show us where the damage area is";
        if (this.props.claimSubmit.hasDamageSelected) {
            damageDetailList = this.props.claimSubmit.claimDamagePhotoTypes.filter((photo) => photo.isSelected === true).map((photoType) => {
                return <>
                    <div className={"row fnol-damage-detail-actual-item-row " + (this.state.damageIsInEdit ? "fnol-damage-detail-edityes" : "fnol-damage-detail-editno")} onClick={() => this.handleRemoveFromList(photoType.description)} title={(this.state.damageIsInEdit ? "Click to remove this item" : "Click on the 'Edit pen' icon to remove this item")}>
                        <div className="col fnol-damage-detail-actual-item-text-col">
                            <span>{photoType.description}</span>
                        </div>
                        <div className="fnol-damage-detail-actual-item-icon-col">
                            <img alt="" src={this.state.damageIsInEdit ? "/my-policy/Images/Claims/red-checkmark-cross.svg" : "/my-policy/Images/Claims/grey-checkmark-checked.svg"} />
                        </div>
                    </div>
                </>
            });
        }
        return (
            <>
                <div className="fnol-preload">
                    <img src={'/my-policy/Images/Claims/Numbers/number-' + this.props.claimSubmit.selectedClaimStep.stepLabel + '-red-32x32px.svg'} alt={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} title={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} />
                    <img src="/my-policy/Images/FNOL/Progress/progress-circle-nugreen.svg" alt="" title="" />
                    <img src="/my-policy/Images/FNOL/Progress/progress-circle-red.svg" alt="" title="" />
                    <img src="/my-policy/Images/FNOL/damage-report-car.svg" alt="" title="" />
                    <img src="/my-policy/Images/FNOL/damage-report-motor-bike.svg" alt="" title="" />
                </div>
                <div className="col ssp-container-fnol-damage-report ssp-container-fnol-step-header-padding">
                    <div className="row noma">
                        <div className="col-12 nopa ssp-header-fnol-damage-report">
                            <div className="row noma">
                                <div className="fnol-step-header-icon-area">
                                    <img src={'/my-policy/Images/Claims/Numbers/number-' + this.props.claimSubmit.selectedClaimStep.stepLabel + '-red-32x32px.svg'} alt={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} title={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} />
                                </div>
                                <div className="col fnol-step-header-title-area">
                                    <h3>Damage report</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row noma">
                        <div className="col-12 fnol-steps-info-section-holder">
                            <hr className="hr-minus21px" />
                            <p className="fnol-damage-report-intro-p">
                                {
                                    (this.props.claimSubmit.claimType === CLAIM_TYPE_GLASS) &&
                                    <>
                                        Select the green dots on the image below to show us where the glass damage is
                                    </>
                                }
                                {
                                    (this.props.claimSubmit.claimType !== CLAIM_TYPE_GLASS) &&
                                    <>
                                        Select the green dots on the image below to show us exactly where the damage is
                                    </>
                                }
                            </p>
                            <div className="fnol-damage-report-legend-container">
                                <div className="fnol-damage-report-legend-1">
                                    <img alt="Not damaged" title="Not damaged" src="/my-policy/Images/FNOL/Progress/progress-circle-nugreen.svg" />
                                    <span>Not damaged</span>
                                </div>
                                <div className="fnol-damage-report-legend-2">
                                    <img alt="Damaged" title="Damaged" src="/my-policy/Images/FNOL/Progress/progress-circle-red.svg" />
                                    <span>Damaged</span>
                                </div>
                            </div>
                            {/*/// DAMAGE VEHICLE SECTIONS BELOW: ///*/}
                            {/*/// GLASS CLAIMS ///*/}
                            {
                                (this.props.claimSubmit.claimType === CLAIM_TYPE_GLASS) &&
                                <div className="fnol-damage-report-car-bike-containers-holder fnol-glassclaims-car-container-holder">
                                    {this.props.claimSubmit.isCar &&
                                        <>
                                            <div className="damage-report-car-container">
                                                <div className="fnol-damage-report-label-top-container">
                                                    <span>Front</span>
                                                </div>
                                                <div className="fnol-damage-report-vehicle-select-area-and-image">
                                                <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-1" id="front-car" onClick={() => this.handleSelectDamagePos('front')} src={this.props.claimSubmit.damageListCar.damageFront ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />
                                                    <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-2" id="left-front-car" onClick={() => this.handleSelectDamagePos('frontLeft')} src={this.props.claimSubmit.damageListCar.damageFrontLeft ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />
                                                    <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-3" id="left-back-car" onClick={() => this.handleSelectDamagePos('backLeft')} src={this.props.claimSubmit.damageListCar.damageBackLeft ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />
                                                    <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-4" id="right-front-car" onClick={() => this.handleSelectDamagePos('frontRight')} src={this.props.claimSubmit.damageListCar.damageFrontRight ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />
                                                    <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-5" id="right-back-car" onClick={() => this.handleSelectDamagePos('backRight')} src={this.props.claimSubmit.damageListCar.damageBackRight ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />
                                                    <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-6" id="back-car" onClick={() => this.handleSelectDamagePos('back')} src={this.props.claimSubmit.damageListCar.damageBack ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />
                                                </div>
                                                <div className="fnol-damage-report-label-bottom-container">
                                                    <span>Back</span>
                                                </div>
                                            </div>
                                        </>
                                    }
                                </div>
                            }
                            {/*/// FNOL CAR AND BIKE ///*/}
                            {
                                (this.props.claimSubmit.claimType !== CLAIM_TYPE_GLASS) &&
                                <>
                                    <div className="fnol-damage-report-car-bike-containers-holder">
                                        {this.props.claimSubmit.isCar &&
                                            <>
                                                <div className="damage-report-car-container">
                                                    <div className="fnol-damage-report-label-top-container">
                                                        <span>Front</span>
                                                    </div>
                                                    <div className="fnol-damage-report-vehicle-select-area-and-image">
                                                        <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-1" id="front-car" onClick={() => this.handleSelectDamagePos('front')} src={this.props.claimSubmit.damageListCar.damageFront ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />
                                                        <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-2" id="left-front-car" onClick={() => this.handleSelectDamagePos('frontLeft')} src={this.props.claimSubmit.damageListCar.damageFrontLeft ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />
                                                        <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-3" id="left-back-car" onClick={() => this.handleSelectDamagePos('backLeft')} src={this.props.claimSubmit.damageListCar.damageBackLeft ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />
                                                        <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-4" id="right-front-car" onClick={() => this.handleSelectDamagePos('frontRight')} src={this.props.claimSubmit.damageListCar.damageFrontRight ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />
                                                        <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-5" id="right-back-car" onClick={() => this.handleSelectDamagePos('backRight')} src={this.props.claimSubmit.damageListCar.damageBackRight ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />
                                                        <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-6" id="back-car" onClick={() => this.handleSelectDamagePos('back')} src={this.props.claimSubmit.damageListCar.damageBack ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />
                                                    </div>
                                                    <div className="fnol-damage-report-label-bottom-container">
                                                        <span>Back</span>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {!this.props.claimSubmit.isCar &&
                                            <>
                                                <div className="damage-report-mb-container">
                                                    <div className="fnol-damage-report-label-top-container">
                                                        <span>Front</span>
                                                    </div>
                                                    <div className="fnol-damage-report-vehicle-select-area-and-image">
                                                        <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-1" id="front-mb" onClick={() => this.handleSelectDamagePos('front')} src={this.props.claimSubmit.damageListCar.damageFront ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />
                                                        <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-2" id="left-front-mb" onClick={() => this.handleSelectDamagePos('frontLeft')} src={this.props.claimSubmit.damageListCar.damageFrontLeft ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />
                                                        <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-3" id="left-back-mb" onClick={() => this.handleSelectDamagePos('backLeft')} src={this.props.claimSubmit.damageListCar.damageBackLeft ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />
                                                        <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-4" id="right-front-mb" onClick={() => this.handleSelectDamagePos('frontRight')} src={this.props.claimSubmit.damageListCar.damageFrontRight ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />
                                                        <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-5" id="right-back-mb" onClick={() => this.handleSelectDamagePos('backRight')} src={this.props.claimSubmit.damageListCar.damageBackRight ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />
                                                        <img alt={damageSelectImgTitle} title={damageSelectImgTitle} className="fnol-damage-select-img-6" id="back-mb" onClick={() =>this.handleSelectDamagePos('back')} src={this.props.claimSubmit.damageListCar.damageBack ? "/my-policy/Images/FNOL/damage-button-red.png" : "/my-policy/Images/FNOL/damage-button-nugreen.png"} />
                                                    </div>
                                                    <div className="fnol-damage-report-label-bottom-container">
                                                        <span>Back</span>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </>
                            }
                            <div className={"fnol-damage-report-select-all " + (this.props.claimSubmit.isCar ? ' fnol-damage-report-select-all-iscar' : 'fnol-damage-report-select-all-isnotcar')}>
                                <div className="row checkAll" onClick={this.handleSelectAll} title="Click to select/deselect all">
                                    <div className="checkAllimgcol">
                                        <img alt="" src={this.state.selectAll ? '/my-policy/Images/FNOL/Rectangle-checked.svg' : '/my-policy/Images/FNOL/Rectangle-unchecked.svg'} />
                                    </div>
                                    <div className="col checkAlltextcol">
                                        <div className="checkAlltext">Select all</div>
                                    </div>
                                </div>
                            </div>
                            {this.props.claimSubmit.hasDamageSelected &&
                                <div className={"damageSelectedHoldingDiv " + (this.props.claimSubmit.hasDamageSelected ? "damageSelectedHoldingDiv-show" : "damageSelectedHoldingDiv-hide")}>
                                    <>
                                        <div className="col-12 nopa">
                                            <div className="row fnol-damage-detail-hr-row">
                                                <div className="col-12 nopa">
                                                    <hr className="hr-minus5px" />
                                                </div>
                                            </div>
                                            <div className="row fnol-damage-detail-header-row" title="Click to start removing items below" onClick={this.handleEditSelectedDamage}>
                                                <div className="col nopa fnol-damage-detail-text-col">
                                                    <h3>Damage detail {this.handleSelectDamagePos} {this.props.claimSubmit.hasDamageSelected}</h3>
                                                </div>
                                                <div className="nopa fnol-damage-detail-icon-col">
                                                    <img alt="" className="arrow" src={this.state.damageIsInEdit ? "/my-policy/Images/Claims/Edit-pen-red.svg" : "/my-policy/Images/Claims/Edit-pen-grey.svg"} />
                                                </div>
                                            </div>
                                            {damageDetailList}
                                        </div>
                                    </>
                                </div>
                            }
                            <div className="nopa fnol-steps-buttonholder">
                                <button className="btn btn-solid-red fnol-buttonreverse-button-next" disabled={this.props.claimSubmit.claimType === CLAIM_TYPE_GLASS && !this.props.claimSubmit.hasDamageSelected} onClick={this.handleSubmitDamageReportStep1}>Next</button>
                                <button className="btn btn-outline-red fnol-buttonreverse-button-back" onClick={this.props.dispatchHandleStepBack}>Back</button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchSetTimeShow: () => dispatch(setTimeShow()),
        dispatchSetStep: (step, subStep) => dispatch(setStep(step, subStep)),
        dispatchHandleStepBack: () => dispatch(handleStepBack()),
        dispatchHandleNextStep: () => dispatch(handleNextStep()),
        dispatchIsInEdit: (isEdit) => dispatch(setIsInEdit(isEdit)),
        dispatchShowSelectedDamageCar: (position) => dispatch(showSelectedDamageCar(position)),
        dispatchShowSelectedDamageMB: (position) => dispatch(showSelectedDamageMB(position)),
        dispatchSetSelectedAllTrue: () => dispatch(setSelectedAllTrue()),
        dispatchSetSelectedAllFalse: () => dispatch(setSelectedAllFalse()),
        dispatchAddDamagePosition: (pos) => dispatch(setDamagePosition(pos)),
        dispatchSetSelectedDamagePhotoTypes: (riskItemType) => dispatch(setSelectedDamagePhotoTypes(riskItemType)),
        dispatchSaveDamageSelected: (description) => dispatch(saveDamageSelected(description)),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchSetGlassDrillDown: (drillDownEnabled, location) => dispatch(setGlassDrillDown(drillDownEnabled, location)),
        dispatchSetGlassTooltip: (damageDescription) => dispatch(setGlassTooltip(damageDescription)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FnolStep5Sub1)